/* Alternix PDP image gallery. No dependencies, zoom or variant-image coupling. */
(() => {
  const galleries = document.querySelectorAll('.product-main-swiper');
  for (const gallery of galleries) {
    if (gallery.dataset.nativeGalleryReady) continue;
    gallery.dataset.nativeGalleryReady = 'true';
    const track = gallery.querySelector(':scope > .swiper-wrapper');
    if (!track) continue;
    const slides = [...track.children].filter(el => el.classList.contains('swiper-slide'));
    const outer = gallery.closest('.product-main__top-gallery');
    const thumbs = [...(outer?.querySelectorAll('.product-main-swiper-thumbs .swiper-slide') || [])];
    let current = 0;
    function show(index, focus = false) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: 'smooth'});
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('swiper-slide-thumb-active', i === current);
        thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
        thumb.setAttribute('tabindex', '0');
        thumb.setAttribute('role', 'button');
        thumb.setAttribute('aria-label', 'Show product image ' + (i+1));
      });
      if (focus) thumbs[current]?.focus();
      gallery.dispatchEvent(new CustomEvent('alternix:gallery-change', {detail:{index:current}}));
    }
    const next = outer?.querySelector('.product-main-swiper-button-next');
    const prev = outer?.querySelector('.product-main-swiper-button-previous');
    for (const [button, delta] of [[next,1],[prev,-1]]) {
      if (!button) continue;
      button.setAttribute('role','button');button.setAttribute('tabindex','0');
      button.setAttribute('aria-label',delta === 1 ? 'Next product image' : 'Previous product image');
      button.addEventListener('click', () => show(current+delta));
      button.addEventListener('keydown', ev => {if (ev.key === 'Enter'||ev.key === ' ') {ev.preventDefault();show(current+delta);}});
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => show(index));
      thumb.addEventListener('keydown', ev => {if (ev.key === 'Enter'||ev.key === ' ') {ev.preventDefault();show(index);}});
    });
    let touchX=0;
    track.addEventListener('touchstart', e => {touchX=e.touches[0]?.clientX||0;}, {passive:true});
    track.addEventListener('touchend', e => {
      const delta=(e.changedTouches[0]?.clientX||0)-touchX;
      if (Math.abs(delta)>40) show(current+(delta<0?1:-1));
    }, {passive:true});
    show(0);
  }
})();
